import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { useEffect } from 'react';
import { toRecentItem } from '../components/dashboard/recent-items';
import type { Tab } from '../store/layoutStoreTypes';
import { useRecentItemsStore } from '../store/recentItemsStore';
import { formatTargetScopeKey } from '../utils/target-scope.utils';

export function useRecordRecentItems({
  activeTab,
  targetId,
  targetType,
}: {
  activeTab: Tab | undefined;
  targetId: string | null;
  targetType: TargetTypeType;
}) {
  const recordRecentItem = useRecentItemsStore(
    (state) => state.recordRecentItem,
  );

  useEffect(() => {
    if (!activeTab || !targetId) {
      return;
    }

    const item = toRecentItem({ tab: activeTab, visitedAt: Date.now() });

    if (item) {
      recordRecentItem({
        scopeKey: formatTargetScopeKey({ targetId, targetType }),
        item,
      });
    }
  }, [activeTab, recordRecentItem, targetId, targetType]);
}
